import React from 'react';
import { version } from '../package.json';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import AppLayout from 'components/AppLayout';
import ToastNotification from 'components/ToastNotification/ToastNotification';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { AnimatePresence, motion } from 'framer-motion';
import { useServiceWorker } from 'toolbox';

let ErrorBoundary;

if (process.env.REACT_APP_BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: (process.env.REACT_APP_BUGSNAG_API_KEY as string) || '',
    plugins: [new BugsnagPluginReact()],
    releaseStage: process.env.REACT_APP_BRANCH || 'unknown',
    appVersion: version || '',
    metadata: {
      company: {
        name: 'JCAP',
      },
    },
  });
  ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React);
}
function App() {
  const app = (
    <Router>
      <Switch>
        {/* this catches the empty path before the 2nd route */}
        <Redirect path="/" exact to="/home" />
        {/* this catches all routes */}
        <Route path="*">
          <AppLayout />
        </Route>
      </Switch>
      <ServiceWorkerAlert />
      <ToastNotification />
    </Router>
  );

  if (process.env.REACT_APP_BUGSNAG_API_KEY && ErrorBoundary)
    return (
      <ErrorBoundary
        FallbackComponent={({ error }) => (
          <div className="text-red-700">{error.message}</div>
        )}
        children={app}
      />
    );

  return app;
}

const ServiceWorkerAlert = () => {
  const { canUpdate, forceUpdate } = useServiceWorker();
  return (
    <>
      <AnimatePresence>
        {canUpdate && (
          <motion.button
            initial={{ y: -56 }}
            animate={{ y: 0 }}
            exit={{ y: -56 }}
            className="fixed top-0 left-0 z-50 block w-full px-8 py-6 bg-red-600 hover:bg-red-700"
            onClick={forceUpdate}
          >
            <p className="font-semibold text-white">
              New updates to this app are available. Click here to update and
              refresh.
            </p>
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
};

export default App;
